const notificationsTranslation = {
  'notifications.error.auth':
    'There was an error logging in, check your credentials and try again.',
  'notifications.success.auth': 'Login successfully!',
  'notifications.error.general':
    'Something went wrong, please, try again later.',
  'notifications.success.general': 'Action taken successfully!',
  'notifications.error.create':
    'Something went wrong when registering this item, please try again later.',
  'notifications.success.create': 'Item registered successfully!',
  'notifications.error.update':
    'Something went wrong when editing this item, please try again later.',
  'notifications.success.update': 'Item edited successfully!',
  'notifications.error.remove':
    'Something went wrong when deleting this item, please try again later.',
  'notifications.success.remove': 'Item deleted successfully!',
  'notifications.error.find':
    'Something went wrong while fetching this item, please try again later.',
  'notifications.error.password': 'Passwords do not match.',
  'notifications.error.email': 'Emails do not match.',
  'notifications.info.development':
    'Under construction, more information soon.',
};

export default notificationsTranslation;
